import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { LanguageService } from 'src/app/services/language.service';

@Component({
  selector: 'app-account-header',
  templateUrl: './account-header.component.html',
  styleUrls: ['./account-header.component.scss'],
  standalone: false
})
export class AccountHeaderComponent implements OnInit {

  @HostListener('document:click', ['$event'])
  onClickEvent(event:any) {
    if (!this.userOuterElement.nativeElement.contains(event.target)){
      this.dropdown = false;
    }
  }
  public dropdown:boolean = false;

  @ViewChild("userOuterEl") userOuterElement:any;

  constructor(public accountService:AccountService,
    public languageService:LanguageService) { }

  ngOnInit(): void {
  }

  public onLogoutClick():void{
    this.accountService.logout();
  }
}
